import { COLORS } from '@btime/constants'
import React from 'react'

import { Title } from '../../../../../components/presentation/Text'
import Separator from '../../../../../components/helpers/Separator'

const ModalHeaderSection = () => {
  return (
    <>
      <Title size="h3" color={COLORS.dark3} noWrap>
        Adicionar Novo Técnico
      </Title>
      <Separator weight={2} />
    </>
  )
}

export default ModalHeaderSection
